import React from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";

import OffersFilter from "../../components/Offers/OffersFilter/OffersFilter";
import OffersList from "../../components/Offers/OffersList/OffersList";
import { OffersProvider } from "../../context/OffersContext";

import "./Offers.css";
import {useSearchParams} from "react-router-dom";

const Offers = () => {
  const [searchParams] = useSearchParams();
  return (
    <div className="page">
      <PageHeader title="Offers" description="Browse eSIM packages for countries and regions." />
      <div className="page-content">
        <OffersProvider initialCountryId={searchParams.get("countryId")} initialRegionId={searchParams.get("regionId")}>
          <div className="offers-layout">
            <section className="offers-sidebar shadow rounded">
              <OffersFilter />
            </section>

            <section className="offers-main shadow rounded">
              <OffersList />
            </section>
          </div>
        </OffersProvider>
      </div>
    </div>
  );
};

export default Offers;
